import { render, staticRenderFns } from "./NewVerticalConfiguration.vue?vue&type=template&id=b52f310a&"
import script from "./NewVerticalConfiguration.vue?vue&type=script&lang=js&"
export * from "./NewVerticalConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports